﻿namespace WebPortal.Navigation {
    export class NavigationUtils {
        public setButtonActivated(buttonName: string, text: string = null): void {
            this.reformatButton(buttonName, true);
            if (text) {
                this.setButtonTitle(buttonName, text);
            }
        }

        public setButtonDeactivated(buttonName: string, text: string): void {
            this.reformatButton(buttonName, false);
            this.setButtonTitle(buttonName, text);
        }

        public showButton(buttonName: string): void {
            let button: JQuery = this.getButton(buttonName);
            if (button && button.length > 0) {
                if (button.hasClass("hidden")) {
                    button.removeClass("hidden");
                }
            }
        }

        public showButtons(buttonNames: Array<string>): void {
            for (let i: number = 0; i < buttonNames.length; i++) {
                this.showButton(buttonNames[i]);
            }
        }

        public enableButton(buttonName: string, attachedFunction: () => any): void {
            let button: JQuery = this.getButton(buttonName);
            if (button && button.length > 0) {
                if (button.hasClass("disabled")) {
                    button.removeClass("disabled");
                }
            }

            if (attachedFunction) {
                let linkButton: JQuery = this.getLinkButton(buttonName);
                if (linkButton && linkButton.length > 0) {
                    linkButton.off().on("click", attachedFunction);
                }
            }
        }

        public enableButtons(buttons: Array<any>): void {
            for (let i: number = 0; i < buttons.length; i++) {
                this.enableButton(buttons[i].name, buttons[i].func);
            }
        }

        public disableButton(buttonName: string): void {
            let button: JQuery = this.getButton(buttonName);
            if (button && button.length > 0) {
                if (!button.hasClass("disabled")) {
                    button.addClass("disabled");
                }
            }

            let linkButton: JQuery = this.getLinkButton(buttonName);
            if (linkButton && linkButton.length > 0) {
                linkButton.off().on("click", () => { return false; });
            }
        }

        public disableButtons(buttonNames: string[]): void {
            for (let i: number = 0; i < buttonNames.length; i++) {
                this.disableButton(buttonNames[i]);
            }
        }

        public isButtonDisabled(buttonName: string): boolean {
            let button: JQuery = this.getButton(buttonName);
            if (button && button.length > 0) {
                if (button.hasClass("disabled")) {
                    return (true);
                }
            }
            return (false);
        }

        public hideButton(buttonName: string): void {
            let button: JQuery = this.getButton(buttonName);
            if (button && button.length > 0) {
                if (!button.hasClass("hidden")) {
                    button.addClass("hidden");
                }
            }
        }

        public hideButtons(buttonNames: Array<string>): void {
            for (let i: number = 0; i < buttonNames.length; i++) {
                this.hideButton(buttonNames[i]);
            }
        }

        public addCounter(buttonName: string, count: number): void {
            let linkButton: JQuery = this.getLinkButton(buttonName);
            if (linkButton && linkButton.length > 0) {
                let counterBadge: JQuery = linkButton.children(".badge");
                if (counterBadge && counterBadge.length > 0) {
                    counterBadge.text(count);
                }
            }
        }

        public removeCounter(buttonName: string): void {
            let linkButton: JQuery = this.getLinkButton(buttonName);
            if (linkButton && linkButton.length > 0) {
                let counterBadge: JQuery = linkButton.children(".badge");
                if (counterBadge && counterBadge.length > 0) {
                    counterBadge.text("");
                }
            }
        }

        public getButton(buttonName: string): JQuery {
            //console.info("getButton: " + buttonName);
            switch (buttonName) {
                case "NewSession":
                    return $("#navigation_li_new_session");
                case "SessionTimeout":
                    return $("#navigation_li_session_timeout");
                case "ToggleUserClient":
                    return $("#navigation_li_toggle_userclient");
                case "ClipboardSync":
                    return $("#navigation_li_clipboard_sync");
                case "SendToRemoteClipboard":
                    return $("#navigation_li_send_to_remote");
                case "ScreenScaling":
                    return $("#navigation_li_screenscaling");
                case "SessionSharing":
                    return $("#navigation_li_session_sharing_enable");
                case "SessionSharingStop":
                    return $("#navigation_li_session_sharing_stop");
                case "SessionSharingPause":
                    return $("#navigation_li_session_sharing_pause");
                case "SessionSharingControl":
                    return $("#navigation_li_session_sharing_control");
                case "SessionInformation":
                    return $("#navigation_li_session_information");
                case "TouchGesture":
                    return $("#navigation_li_session_touch_gesture");
                case "JoinSession":
                    return $("#navigation_li_join_session");
                case "FileTransfer":
                    return $("#navigation_li_file_transfer");
                case "FileTransferSession":
                    return $("#navigation_li_session_file_transfer");
                case "AccountInformation":
                    return $("#navigation_li_account_information");
                case "Notification":
                    return $("#navigation_li_notification_center");
                case "Upload":
                    return $("#navigation_li_upload");
                case "DriveSwisscom":
                    return $("#navigation_bt_drive_swisscom");
                case "DriveAccessGroup":
                    return $("#navigation_bt_drive_accessgroup");
                case "DrivePrivate":
                    return $("#navigation_bt_drive_private");
                case "NewFolder":
                    return $("#navigation_li_new_folder");
                case "RefreshList":
                    return $("#navigation_li_refresh_list");
                case "MultipleDeletion":
                    return $("#navigation_li_multiple_deletion");
                case "MultipleDownload":
                    return $("#navigation_li_multiple_download");
                case "SearchFor":
                    return $("#navigation_li_search_for");
                case "Feedback":
                    return $("#navigation_li_feedback");
                case "ContactAndLegal":
                    return $("#navigation_li_contact_and_legal");
                case "DownloadAllConnectCertificate":
                    return $("#navigation_footer_li_download_allconnect_certificate");
                case "DownloadClient":
                    return $("#navigation_footer_li_download_client");
                default:
                    return;
            }
        }

        public setButtonTitle(buttonName: string, text: string): void {
            let button: JQuery = this.getButton(buttonName);
            if (button && button.length > 0) {
                if (text) {
                    button.children().children(".nav-element").text(text);
                    if ($("#hdf_navstate").val() === "collapsed") {
                        button.attr({ "title": text });
                    } else {
                        button.children(".nav-image").removeAttr("title");
                    }
                }
            }
        }

        public getLinkButton(buttonName: string): JQuery {
            let button: JQuery = this.getButton(buttonName);
            if (button && button.length > 0) {
                return button.children("a").first();
            }
            return null;
        }

        public addStriplineBeforeButton(buttonName: string): void {
            let button: JQuery = this.getButton(buttonName);
            if (button && button.length > 0) {
                let previousButton: JQuery = $(button).prev();
                if (previousButton.children("hr").length === 0) {
                    $(button).before("<li><hr></li>");
                }
            }
        }

        public removeStriplineBeforeButton(buttonName: string): void {
            let button: JQuery = this.getButton(buttonName);
            if (button && button.length > 0) {
                let previousButton: JQuery = $(button).prev();
                if (previousButton.children("hr").length > 0) {
                    previousButton.remove();
                }
            }
        }

        private reformatButton(buttonName: string, shouldSetToActivate: boolean): void {
            if (shouldSetToActivate) {
                this.formatToBlue(buttonName);
            } else {
                this.formatToDefault(buttonName);
            }
        }

        private formatToBlue(buttonName: string): void {
            this.formatToColor(buttonName, "#11aaff");
        }

        public formatToRed(buttonName: string): void {
            this.formatToColor(buttonName, "#dd1122");
        }

        private formatToColor(buttonName: string, hexColor: string): void {
            let button: JQuery = this.getButton(buttonName);
            if (button && button.length > 0) {
                let newCss: Object = {
                    "background": hexColor,
                    "color": "#fff",
                    "border-top": "1px solid #383838"
                };

                $(button)
                    .children("a")
                    .css(newCss)
                    .hover((e: JQueryEventObject) => {
                        $(e.currentTarget).css(newCss);
                    });
            }
        }

        private formatToDefault(buttonName: string): void {
            let button: JQuery = this.getButton(buttonName);
            if (button && button.length > 0) {
                let newCss: Object = {
                    "background": "#383838",
                    "color": "#fff"
                };

                $(button)
                    .children("a")
                    .css(newCss)
                    .hover((e: JQueryEventObject) => {
                        $(e.currentTarget).css({
                            "background": "#f5f5f5",
                            "color": "#383838"
                        });
                    }, (e: JQueryEventObject) => {
                        $(e.currentTarget).css(newCss);
                    });
            }
        }
    }
}